import {
  HomeOutlined,
  DatabaseOutlined,
  EnvironmentOutlined,
  DoubleRightOutlined,
  CheckCircleOutlined,
  BulbOutlined,
  FileTextOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { SidebarItem } from '_/components/common/layout/AppSidebar';
import { useCollection } from '_/contexts/CollectionContext';
import React, { useMemo } from 'react';

// Create icon elements once to prevent re-renders
const homeIcon = <HomeOutlined />;
const databaseIcon = <DatabaseOutlined />;
const environmentIcon = <EnvironmentOutlined />;
const doubleRightIcon = <DoubleRightOutlined />;
const checkCircleIcon = <CheckCircleOutlined />;
const bulbIcon = <BulbOutlined />;
const fileTextIcon = <FileTextOutlined />;
const settingIcon = <SettingOutlined />;

export function useCollectionSidebarItems(orgSlug: string, projectSlug: string, collectionSlug: string): SidebarItem[] {
  const { selectedCollection } = useCollection();
  const schemaSlug = selectedCollection?.schema?.slug;

  return useMemo(() => {
    const items: SidebarItem[] = [
      {
        icon: homeIcon,
        text: 'Collection Home',
        href: `/orgs/${orgSlug}/projects/${projectSlug}/collections/${collectionSlug}/home`,
      },
      {
        icon: databaseIcon,
        text: 'Sources',
        href: `/orgs/${orgSlug}/projects/${projectSlug}/collections/${collectionSlug}/sources`,
      },
      {
        icon: environmentIcon,
        text: 'Destinations',
        href: `/orgs/${orgSlug}/projects/${projectSlug}/collections/${collectionSlug}/destinations`,
      },
      {
        icon: doubleRightIcon,
        text: 'Pushes',
        href: `/orgs/${orgSlug}/projects/${projectSlug}/collections/${collectionSlug}/pushes`,
      },
      {
        icon: checkCircleIcon,
        text: 'Checks',
        href: `/orgs/${orgSlug}/projects/${projectSlug}/collections/${collectionSlug}/checks`,
      },
      {
        icon: bulbIcon,
        text: 'Snapshot Spotlight',
        href: `/orgs/${orgSlug}/projects/${projectSlug}/collections/${collectionSlug}/snapshotspotlight`,
      },
    ];

    if (schemaSlug) {
      items.push({
        icon: fileTextIcon,
        text: 'Schema',
        href: `/orgs/${orgSlug}/schemas/${schemaSlug}`,
        status: 'external',
      });
    }

    items.push({
      icon: settingIcon,
      text: 'Settings',
      href: `/orgs/${orgSlug}/projects/${projectSlug}/collections/${collectionSlug}/settings`,
    });

    return items;
  }, [orgSlug, projectSlug, collectionSlug, schemaSlug]);
}
